import React, { useState } from "react";
import "../App.css";

const menuList = [
  { key: "calibration", label: "零漂/量漂校准" },
  { key: "indication", label: "示值误差" },
  { key: "comparison", label: "比对计算" },
  { key: "humidity-conversion", label: "干湿转换" },
  { key: "image-recognition", label: "台账AI核验" },
  { key: "ai-inspection", label: "站房AI巡检" },
];

const Navbar = ({ activeModule, setActiveModule }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="menu-bar-responsive">
      <div className="navbar-title">AI运维</div>
      <div className="navbar-spacer" />
      {/* PC菜单 */}
      <div className="navbar-menu-list">
        {menuList.map((item) => (
          <span
            key={item.key}
            className={`menu-item${activeModule === item.key ? " active" : ""}`}
            onClick={() => setActiveModule(item.key)}
          >
            {item.label}
          </span>
        ))}
      </div>
      {/* 移动端汉堡按钮 */}
      <button
        className="navbar-hamburger"
        onClick={() => setMobileOpen((v) => !v)}
        aria-label="菜单"
      >
        <span className="hamburger-bar" />
        <span className="hamburger-bar" />
        <span className="hamburger-bar" />
      </button>
      {/* 移动端下拉菜单 */}
      {mobileOpen && (
        <div className="navbar-mobile-menu" onClick={() => setMobileOpen(false)}>
          {menuList.map((item) => (
            <span
              key={item.key}
              className={`menu-item${activeModule === item.key ? " active" : ""}`}
              onClick={() => setActiveModule(item.key)}
            >
              {item.label}
            </span>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;